import Immutable from 'immutable';
import * as Models from 'models';

export const applyOverridenPadding = (
  brandStylePadding: Models.BoxProperty,
  sourceStylePadding: Models.BoxProperty,
  styles: Models.TextRelationStyles,
): void => {
  const relationPadding = styles.padding;
  const overrideValues = {};

  if (!relationPadding) {
    return;
  }

  for (const [direction, value] of Object.entries(sourceStylePadding)) {
    if (value !== relationPadding[direction]) {
      overrideValues[direction] = relationPadding[direction];
    }
  }

  styles.padding = Immutable.mergeDeep(brandStylePadding, overrideValues);
};
